import { useEntityList } from '@/shared/hooks/useEntityList';
import type { RootState } from '@/store';
import {
  fetchBrokenSubscriptions,
  setBrokenSubscriptionsFilters,
  setBrokenSubscriptionsPage,
  setBrokenSubscriptionsPerPage,
} from '../store/slice';
import type { BrokenSubscription, BrokenSubscriptionFilters } from '../types';

export const useBrokenSubscriptions = () => {
  const result = useEntityList<BrokenSubscription, BrokenSubscriptionFilters>({
    selector: (state: RootState) => state.brokenSubscriptionsEntity,
    fetchAction: fetchBrokenSubscriptions,
    deleteAction: () => Promise.reject(new Error('Broken subscriptions are read-only')),
    setPageAction: setBrokenSubscriptionsPage,
    setPerPageAction: setBrokenSubscriptionsPerPage,
    setFiltersAction: setBrokenSubscriptionsFilters,
    defaultFilters: {
      search: '',
      dateRange: null,
      problemCode: '',
      status: '',
    },
    entityName: 'Broken Subscription',
  });

  return {
    brokenSubscriptions: result.items,
    loading: result.loading,
    error: result.error,
    currentPage: result.currentPage,
    perPage: result.perPage,
    total: result.total,
    lastPage: result.lastPage,
    filters: result.filters,
    handlePageChange: result.handlePageChange,
    handlePerPageChange: result.handlePerPageChange,
    handleFiltersChange: result.handleFiltersChange,
    handleClearFilters: result.handleClearFilters,
  };
};
